export default "__VITE_ASSET__BTb1InoU__"